import { Scene } from "../../tools/Scene";
import { Button } from "../../ui/Button";
import { LocalizationManager } from '../../managers/LocalizationManager';
import EventEmitter from 'eventemitter3';

export class HTPScene{

    containerHTP:Phaser.GameObjects.Image|null = null;
    containerText:Phaser.GameObjects.Text|null = null;

    nextHTPButton:Button|null = null;
    prevHTPButton:Button|null = null;

    open:boolean = false;
    htpIndex:number = 0;
    htpIndexLength:number;

    scene:Scene;
    group:Phaser.GameObjects.Group;

    emitter:EventEmitter = new EventEmitter();
    
    constructor(scene:Scene,landscapePosition:Phaser.Math.Vector2,htpIndexLength:number){
        this.scene = scene;

        this.htpIndexLength = htpIndexLength;

        let position;
        let style;
        let button:Button;
        let text;
        let textString;
        let image:Phaser.GameObjects.Image;
        let group = scene.add.group({});
        this.group = group;

        position = landscapePosition;

        image = scene.add.image(position.x,position.y-100,'htp');
        group.add(image);
        this.containerHTP = image;

        textString = "{{How To Play Instructions}}";
        style = undefined;
        text = scene.add.text(position.x,position.y+120,textString,style);
        text.setOrigin(.5,.5);
        group.add(text);
        this.containerText = text;

        button = new Button(scene,'next_button',position.x+320,position.y);
        button.buttonPressedSprite = 'next_button_pressed';
        button.buttonHighlightSprite = 'next_button';
        button.emitter.on('buttonup',this.nextHTP,this);
        group.addMultiple(button.group.getChildren());
        this.nextHTPButton = button;

        button = new Button(scene,'next_button',position.x-320,position.y);
        button.buttonPressedSprite = 'next_button_pressed';
        button.buttonHighlightSprite = 'next_button';
        button.emitter.on('buttonup',this.previousHTP,this);
        group.addMultiple(button.group.getChildren());
        this.prevHTPButton = button;
        button.sprite.setFlipX(true);

        //Init
        this.updateHTP();
    }

    reorient(landscape:boolean){
        let position;
        if(landscape){
            if(this.containerHTP){
                position = this.scene.scaleManager.getRelativePosition(0.5,0.5,true);
                this.containerHTP!.setPosition(position.x,position.y-60);
                this.containerText!.setPosition(position.x,position.y+60);
                Phaser.Actions.SetXY(this.nextHTPButton!.group.getChildren(),position.x+320,position.y);
                Phaser.Actions.SetXY(this.prevHTPButton!.group.getChildren(),position.x-320,position.y);
            }
        }else{
            if(this.containerHTP){
                position = this.scene.scaleManager.getRelativePosition(0.5,0.5,true);
                this.containerHTP!.setPosition(position.x,position.y-60);
                this.containerText!.setPosition(position.x,position.y+60);
                Phaser.Actions.SetXY(this.nextHTPButton!.group.getChildren(),position.x+320,position.y);
                Phaser.Actions.SetXY(this.prevHTPButton!.group.getChildren(),position.x-320,position.y);
            }
        }
    }

    nextHTP(){
        this.htpIndex++;
        if(this.htpIndex==this.htpIndexLength){
            this.htpIndex=0;
        }
        this.updateHTP();
    }

    previousHTP(){
        this.htpIndex--;
        if(this.htpIndex==-1){
            this.htpIndex=this.htpIndexLength-1;
        }
        this.updateHTP();
    }

    updateHTP(){
        if(this.containerText){
            let touchID = "HTP_INSTRUCTIONS_TOUCH_" + this.htpIndex;
            let notouchID = "HTP_INSTRUCTIONS_" + this.htpIndex;
            //console.log("touchID:"+touchID);
            //console.log("notouchID:"+notouchID);
            let textString = this.scene.gameManager.game!.device.input.touch ? LocalizationManager.getText(touchID) : LocalizationManager.getText(notouchID);
            let style = this.scene.gameManager.game!.device.input.touch ? LocalizationManager.getStyle(touchID) : LocalizationManager.getStyle(notouchID);
            this.containerText.setText(textString);
            this.containerText.setStyle(style);
        }
        if(this.containerHTP){
            let imageID = "htp" + this.htpIndex;
            this.containerHTP.setTexture(imageID);
        }
    }
}